// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/lock-closed.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'lock-closed',
  version: 'outline',
  paths: [
    {
      id: 'shackle',
      d: 'M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75',
    },
    {
      d: 'M6.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z',
    },
  ],
}
